import { ApiClient } from '@busbook/ui';
import type { Capability } from '@busbook/shared';

export const api = new ApiClient({
  baseUrl: '/api/v1',
  storageKey: 'busbook.admin.tokens',
  refreshPath: '/admin/auth/refresh',
  onAuthLost: () => window.dispatchEvent(new CustomEvent('busbook:auth-lost')),
});

export interface TenantSummary {
  id: string;
  slug: string;
  name: string;
  status: 'ONBOARDING' | 'ACTIVE' | 'SUSPENDED';
  timezone: string;
  currency: string;
  settings: {
    currency: string;
    timezone: string;
    reminderLeadMinutes: number;
    cancellationCutoffHours: number;
    paymentWindowMinutes: number;
    maxSeatsPerBooking: number;
    supportEmail: string;
    supportPhone: string;
    aboutHtml: string;
    faqHtml: string;
  };
}

export interface StaffUser {
  id: string;
  email: string;
  name: string;
  phone: string | null;
  /** Null means no picture; the interface falls back to initials. */
  avatarUrl: string | null;
  /** Legacy, and null for a genuinely custom role. Nothing in this app reads it any more --
   *  navigation and the Staff screen both key off tenantRoleName / capabilities instead. */
  role: ('OWNER' | 'MANAGER' | 'OPERATOR' | 'SUPPORT') | null;
  tenantId: string;
  tenantRoleId: string | null;
  tenantRoleName: string | null;
  /** What the server resolved this account's role to grant, right now (custom staff roles). */
  capabilities: Capability[];
}
